// 预约状态 00未到访 01已到访 02已取消 03已过期
export enum VisitStatus {
  NotVisit = '00',
  YesVisit = '01',
  HasBeenCancelled = '02',
  Expired = '03'
}

export const visitStatusMap: {
  [key: string]: string;
} = {
  [VisitStatus.NotVisit]: '未到访',
  [VisitStatus.YesVisit]: '已到访',
  [VisitStatus.HasBeenCancelled]: '已取消',
  [VisitStatus.Expired]: '已过期'
};
